/**
 * Analytics events object keys dictionary
 */
export enum AnalyticsMetaKeys {
    // ads
    AD_SITE = 'Ad Site', // = conf.ads.adsite

    // analytics
    BRAND = 'Brand',
    DOMAIN = 'Domain',
    VENDOR = 'Vendor',
    DIVISION = 'Division',
    DEBUG = 'Analytics Debug info',

    // page
    ARTICLE_ID = 'Article ID',
    AUTHORS = 'Authors',
    BTN_LOC = 'Button Location',
    CANONICAL_PATH = 'Canonical Page Path',
    CATEGORY = 'Category',
    CUR_PAGE = 'Current Page',
    DISTRIBUTOR = 'Distributor',
    KLNGO_ENTITY = 'Entity',
    KLNGO_CATEGORY = 'NLP Category',
    ERROR = '404',
    EXCERPT = 'Excerpt',
    FORMAT = 'Article Format',
    GLOBAL_ID = 'Global Post ID',
    HEADLINE = 'Alternate Headline',
    IS_ORIGINAL = 'Originating Property',
    META_ROBOT = 'Meta Robots Tag',
    META_DESC = 'Meta Description',
    META_TAG = 'WordPress Meta Tag Keywords',
    MOD_DATE = 'Modification Date',
    MOD_TIME = 'Modification time of day',
    MP_ID = 'MPID',
    NAME = 'Page Name',
    NEWS_KEYWRD = 'Google News Keywords',
    ORIGINAL_ID = 'Original ID',
    PAYWALL = 'Paywall Whitelist',
    PUB_DATE = 'Publish Date',
    PUB_TIME = 'Publish time of day',
    SLUG = 'Global Slug',
    SPONSOR = 'Sponsor',
    SUB_SEC = 'Sub Section',
    SUB_SEC_2 = 'Sub Section 2',
    SUB_SEC_3 = 'Sub Section 3',
    TITLE = 'Article Title',
    TYPE = 'Page Type',
    URL = 'URL',
    USER_LOGGEDIN = 'Login Status',
    VID_IN_PAGE = 'Video In Page',
    WRD_CNT = 'Word Count',

    // Video attributes
    VID_ID_FRM_PLYLST = 'Video ID From Playlist Widget',
    VID_NAME = 'Video Name',
    VID_PLATFORM = 'Video Platform',
    VID_AUTHOR = 'Video Author',
    VID_ID = 'Video ID',
    VID_CENTER = 'Video Center',
    VID_QUALITY = 'Video Quality',
    VID_PUB_DATE = 'Video Publish Date',
    VID_NAME_PATH = 'Video Name Path',
    VID_PLAYER_NAME = 'Video Player Name',
    VID_CONT_TYPE = 'Video Content Type',
    VID_ERROR_MSG = 'Video Error Message',
    VID_FEATURED = 'Featured Video',

    // Attribute related to scroll events
    PAGEVIEW_PRCNT = 'Percentage of Page Viewed',
    PAGEVIEW_INIT_PRCNT = 'Initial Percentage of Page Viewed',

    // Attributes related to Widget events
    WDGT_NAME = 'Widget Name',
    WDGT_POS = 'Widget Position',
    WDGT_TYPE = 'Widget Type',

    // Widget feed
    WDGT_FEED = 'Feed',
    WDGT_FEED_TYPE = 'Feed Type',
    WDGT_FEED_ID = 'Feed ID',
    WDGT_FEED_NAME = 'Feed Name',
    WDGT_FEED_POS = 'Feed Position',
    // Widget story
    WDGT_STORY_POS = 'Story Position',
    WDGT_CLCKD_STORY_ID = 'Clicked Story ID',
    WDGT_CLCKD_STORY_TITLE = 'Clicked Story Title',
    // Widget video
    WDGT_VID_PLYLST_ID = 'Playlist ID',
    WDGT_VID_PLYLST_WDGT_ID = 'Playlist Widget ID',
    WDGT_VID_PLTFRM = 'Widget Video Platform',
    WDGT_VID_ID = 'Widget Video ID',

    // Navigation
    NAV_NAME = 'Name',
    NAV_LOC = 'Navigation Location',
    NAV_CLICK = 'Navigation Click',

    // Viafoura
    VIA_TOTAL_CMNTS = 'Total Comments',
    VIA_DATE_CRETED = 'Date Created',
    VIA_TOTAL_CMNTS_MADE = 'Total Comments Made',
    VIA_TOTAL_CMNTS_RCVD = 'Total Comments Received (replies)',
    VIA_RNK_CMNTS_MADE = 'Rank Comments Made',
    VIA_RNK_CMNTS_RCVD = 'Rank Comments Received',
    VIA_RNK_CMNTS_OVRAL = 'Comments Rank Overall',
    VIA_RNK_SUB_CNT = 'Comments Rank Subscriber Count',
    VIA_CMNTS_RTNG = 'Comments Rating',
    VIA_CMNTS_LVL = 'Comment level',
    VIA_CMNTS_TYP = 'Comment type',

    VIA_SCL_LGIN_ID = 'Social Login ID',
    VIA_SCL_LGIN_PRDR = 'Social Login Provider',
    VIA_USR_PRVLG = 'User Privilege',

    VIA_DISLK_RCVD = 'Dislike (Received)',
    VIA_DISLK_MADE = 'Dislike (Made)',
    VIA_LIKE_MADE = 'Like (Made)',
    VIA_LIKE_RCVD = 'Like (Received)',

    // Social share
    SCL_SHARE_CHANNEL = 'Share Channel',
    SCL_SHARE_LOC = 'Share Location On Page',

    // Search event
    SRCH_KEY_WORDS = 'Search Terms',
    SRCH_RSLT_CNT = 'Search Result Count',

    // Campaign event
    CMPGN_ID = 'Campaign ID',
    CMPGN_TYPE = 'Campaign Type',

    // Internal promotion click
    INTRNL_PROM_NAME = 'Promotion Name',

    // subscribe button click
    SUB_BTN_ACTN = 'Action',
    SUB_BTN_NEWS = 'Newsletters',
    SUB_BTN_SRC = 'Source',
    SUB_BTN_TOPIC = 'Topics subscribed',

    // Video center
    OUTFIT = 'Outfit',
    OUTFIT_POS = 'Outfit Position',

    // Identity
    USER_EMAIL = 'email',
    USER_JANRAIN_ID = 'janrainId',
    USER_GLBL_COOKIE = 'globalCookieId',

    // User attribute
    USER_CLAIMED_19_PLUS = 'Claimed 19+',
    USER_PROVINCE = '$State',
    USER_PST_CDE = '$Zip',
    USER_MPID = 'MPID',

    USER_VIEW_SIGN_REG_MODULE = 'Registration/Sign In Module Trigger',
    USER_ACNT_STATUS = 'Status',
    USER_SIGNIN_MTHD = 'Sign In Method',
    TRUE_FALSE = 'T/F',

    // Button
    BTN_NAME = 'Button Name',
    BTN_TEXT = 'Button Text',
    BTN_URL = 'Button URL',

    // Photo Gallery
    PHOTO_NAME = 'Photo Name',

    // Error Page
    ERROR_MSG = 'Error Message'
}
